// extracted by mini-css-extract-plugin
export default {"textClassName":"_1b6l7","circleClassName":"pu99z","regionClassName":"_2EFo4"};